export default "__VITE_ASSET__BJP2mfW0__"